/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePhotoDoc } from '../models/CreatePhotoDoc';
import type { PhotoDocConstructionSitesResponse } from '../models/PhotoDocConstructionSitesResponse';
import type { PhotoDocDownloadManifest } from '../models/PhotoDocDownloadManifest';
import type { PhotoDocFullImage } from '../models/PhotoDocFullImage';
import type { PhotoDocHistory } from '../models/PhotoDocHistory';
import type { PhotoDocManagerAccountsResponse } from '../models/PhotoDocManagerAccountsResponse';
import type { PhotoDocPhotosResponse } from '../models/PhotoDocPhotosResponse';
import type { PhotoDocRecentPhotosResponse } from '../models/PhotoDocRecentPhotosResponse';
import type { PhotoDocWorkPackages } from '../models/PhotoDocWorkPackages';
import type { PhotoDocWorkPackagesResponse } from '../models/PhotoDocWorkPackagesResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PhotoDocumentationService {
    /**
     * returns the count of permanently failed mobile uploads
     * @param tenantId tenant_id
     * @returns any always returns { count: integer }; 0 when no record exists
     * @throws ApiError
     */
    public static getPhotoDocFailedMobileUploads(
        tenantId: string,
    ): CancelablePromise<{
        count: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/resources/photo_documentation/failed_mobile_uploads',
            path: {
                'tenant_id': tenantId,
            },
            errors: {
                401: `unauthorized when employee does not have access to the tenant`,
                403: `forbidden when employee lacks can_create_photo_documentation ability`,
            },
        });
    }
    /**
     * upserts the count of permanently failed mobile uploads
     * @param tenantId tenant_id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putPhotoDocFailedMobileUploads(
        tenantId: string,
        requestBody?: {
            count: number;
        },
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/tenants/{tenant_id}/resources/photo_documentation/failed_mobile_uploads',
            path: {
                'tenant_id': tenantId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `unauthorized when employee does not have access to the tenant`,
                403: `forbidden when employee lacks can_create_photo_documentation ability`,
            },
        });
    }
    /**
     * lists work packages the current employee may upload photos to
     * @param tenantId tenant_id
     * @returns PhotoDocWorkPackages successful
     * @throws ApiError
     */
    public static getPhotoDocWorkPackages(
        tenantId: string,
    ): CancelablePromise<PhotoDocWorkPackages> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/resources/photo_documentation/work_packages',
            path: {
                'tenant_id': tenantId,
            },
            errors: {
                401: `unauthorized when employee does not have access to the tenant`,
                403: `forbidden when employee lacks can_create_photo_documentation ability`,
            },
        });
    }
    /**
     * creates a photo documentation entry
     * @param tenantId tenant_id
     * @param requestBody
     * @returns any created
     * @throws ApiError
     */
    public static createPhotoDoc(
        tenantId: string,
        requestBody?: CreatePhotoDoc,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tenants/{tenant_id}/resources/photo_documentation',
            path: {
                'tenant_id': tenantId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `unauthorized when employee does not have access to the tenant`,
                403: `forbidden when employee lacks can_create_photo_documentation ability`,
                422: `unprocessable entity when uploads are missing`,
            },
        });
    }
    /**
     * assigns a photo doc to a work package or construction site manager
     * @param tenantId tenant_id
     * @param id photo doc id
     * @param requestBody
     * @returns any assigned to work package
     * @throws ApiError
     */
    public static assignPhotoDoc(
        tenantId: string,
        id: string,
        requestBody?: {
            work_package_id?: string | null;
            construction_site_manager_id?: string | null;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tenants/{tenant_id}/resources/photo_documentation/{id}/assign',
            path: {
                'tenant_id': tenantId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `unauthorized when employee does not have access to the tenant`,
                403: `forbidden when employee lacks can_assign_photo_documentation ability`,
                404: `not found when photo doc does not exist`,
                422: `unprocessable entity`,
            },
        });
    }
    /**
     * lists the history events of a photo documentation
     * @param tenantId tenant_id
     * @param id photo doc id
     * @returns PhotoDocHistory successful
     * @throws ApiError
     */
    public static getPhotoDocHistory(
        tenantId: string,
        id: string,
    ): CancelablePromise<PhotoDocHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/resources/photo_documentation/{id}/history',
            path: {
                'tenant_id': tenantId,
                'id': id,
            },
            errors: {
                403: `forbidden when employee lacks both view and create photo documentation abilities`,
                404: `not found when the photo doc belongs to another tenant`,
            },
        });
    }
    /**
     * Soft-deletes a single photo of a photo documentation
     * @param tenantId tenant_id
     * @param id photo id
     * @returns void
     * @throws ApiError
     */
    public static deletePhotoDocPhoto(
        tenantId: string,
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/tenants/{tenant_id}/resources/photo_documentation/photos/{id}',
            path: {
                'tenant_id': tenantId,
                'id': id,
            },
            errors: {
                403: `forbidden when employee lacks can_delete_photo_documentation ability`,
                404: `photo not found in current tenant`,
                422: `deletion window expired (older than 1 month)`,
            },
        });
    }
    /**
     * Soft-deletes a whole photo documentation group and its photos
     * @param tenantId tenant_id
     * @param id photo_doc id
     * @returns void
     * @throws ApiError
     */
    public static deletePhotoDoc(
        tenantId: string,
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/tenants/{tenant_id}/resources/photo_documentation/photo_docs/{id}',
            path: {
                'tenant_id': tenantId,
                'id': id,
            },
            errors: {
                403: `forbidden when employee lacks can_delete_photo_documentation ability`,
                422: `deletion window expired (older than 1 month)`,
            },
        });
    }
    /**
     * Returns recent photos uploaded by current user
     * @param tenantId tenant_id
     * @param limit Max number of recent photos to return (1-20, default 3)
     * @returns PhotoDocRecentPhotosResponse Respects limit parameter
     * @throws ApiError
     */
    public static getApiTenantsResourcesPhotoDocumentationMyRecentPhotos(
        tenantId: string,
        limit?: number,
    ): CancelablePromise<PhotoDocRecentPhotosResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/resources/photo_documentation/my_recent_photos',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'limit': limit,
            },
        });
    }
    /**
     * Returns photo docs assigned to a manager account (no work package)
     * @param tenantId tenant_id
     * @param managerId
     * @returns PhotoDocManagerAccountsResponse Manager account photo docs
     * @throws ApiError
     */
    public static getApiTenantsResourcesPhotoDocumentationManagerAccounts(
        tenantId: string,
        managerId?: string,
    ): CancelablePromise<PhotoDocManagerAccountsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/resources/photo_documentation/manager_accounts',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'manager_id': managerId,
            },
        });
    }
    /**
     * Returns construction sites with photo docs
     * @param tenantId tenant_id
     * @param managerId
     * @returns PhotoDocConstructionSitesResponse Construction sites
     * @throws ApiError
     */
    public static getApiTenantsResourcesPhotoDocumentationConstructionSites(
        tenantId: string,
        managerId?: string,
    ): CancelablePromise<PhotoDocConstructionSitesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/resources/photo_documentation/construction_sites',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'manager_id': managerId,
            },
        });
    }
    /**
     * Returns work packages with photo docs for a construction site
     * @param tenantId
     * @param constructionSiteId
     * @returns PhotoDocWorkPackagesResponse Work packages
     * @throws ApiError
     */
    public static getApiTenantsResourcesPhotoDocumentationConstructionSitesWorkPackages(
        tenantId: string,
        constructionSiteId: string,
    ): CancelablePromise<PhotoDocWorkPackagesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/resources/photo_documentation/construction_sites/{construction_site_id}/work_packages',
            path: {
                'tenant_id': tenantId,
                'construction_site_id': constructionSiteId,
            },
        });
    }
    /**
     * Returns photos grouped by date for a work package
     * @param tenantId
     * @param workPackageId
     * @param startDate
     * @param endDate
     * @returns PhotoDocPhotosResponse Photos grouped by date
     * @throws ApiError
     */
    public static getApiTenantsResourcesPhotoDocumentationWorkPackagesPhotos(
        tenantId: string,
        workPackageId: string,
        startDate?: string,
        endDate?: string,
    ): CancelablePromise<PhotoDocPhotosResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/resources/photo_documentation/work_packages/{work_package_id}/photos',
            path: {
                'tenant_id': tenantId,
                'work_package_id': workPackageId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                404: `Blue collar worker not assigned to construction site`,
            },
        });
    }
    /**
     * Returns a presigned URL to the full-resolution photo
     * @param tenantId tenant_id
     * @param id photo id
     * @param disposition Pass 'attachment' to make the URL download instead of display
     * @returns PhotoDocFullImage Full image URL
     * @throws ApiError
     */
    public static getApiTenantsResourcesPhotoDocumentationPhotosFull(
        tenantId: string,
        id: string,
        disposition?: string,
    ): CancelablePromise<PhotoDocFullImage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/resources/photo_documentation/photos/{id}/full',
            path: {
                'tenant_id': tenantId,
                'id': id,
            },
            query: {
                'disposition': disposition,
            },
            errors: {
                403: `Forbidden`,
                404: `Not found`,
            },
        });
    }
    /**
     * Returns the archive manifest for a photo group
     * @param tenantId tenant_id
     * @param id photo doc id
     * @returns PhotoDocDownloadManifest Download manifest
     * @throws ApiError
     */
    public static getApiTenantsResourcesPhotoDocumentationPhotoDocsDownloadManifest(
        tenantId: string,
        id: string,
    ): CancelablePromise<PhotoDocDownloadManifest> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/resources/photo_documentation/photo_docs/{id}/download_manifest',
            path: {
                'tenant_id': tenantId,
                'id': id,
            },
            errors: {
                403: `Forbidden`,
                404: `Not found`,
                409: `Photos of the group are still being converted`,
            },
        });
    }
}
